import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useWithdrawHoldedMoneyMutation } from '@/api/queries/user';
import { H1, TextSmall } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';
import { selectHoldedBalanceByItems } from '@/redux/selectors/userSelectors';
import { useAppSelector } from '@/redux/store';

import { BalanceItem } from '../BalanceItem/BalanceItem';

import css from './styles.module.scss';

const PartnersMainInfo: FC = () => {
  const { t } = useTranslation();
  const [claimHoldedMoney, { isLoading }] = useWithdrawHoldedMoneyMutation();
  const holdedBalance = useAppSelector((state) =>
    selectHoldedBalanceByItems(state, ['usdt', 'cash', 'tgem']),
  );

  const hasRewardsToClaim = holdedBalance?.some(({ value }) => !!value);

  return (
    <div className="w-full flex flex-col gap-2 items-center mb-4">
      <H1 weight="extrabold">{t('Partners')}</H1>
      <TextSmall
        weight="regular"
        className="!text-white/60 leading-1.2 text-center max-w-[21.25rem] mb-2"
      >
        {t(
          'Share your link and earn rewards as partnersplay, level up, and make purchases',
        )}
      </TextSmall>
      <div className="w-full px-4 flex flex-col">
        <div className="w-full flex mb-2 gap-[0.25rem]">
          {holdedBalance?.map((props) => (
            <BalanceItem
              className={props.name === 'cash' ? css.line : ''}
              key={props.name}
              {...props}
            />
          ))}
        </div>
        <MainButton
          onClick={() => claimHoldedMoney()}
          isLoading={isLoading}
          disabled={isLoading || !hasRewardsToClaim}
          inactive={!hasRewardsToClaim}
          text={t('Claim rewards')}
        />
      </div>
    </div>
  );
};

export { PartnersMainInfo };
